<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" max-width="500">
      <template v-slot:activator="{ on }">
        <v-btn small flat color="success" dark v-on="on" @click="check_user" >Deposer</v-btn>
      </template>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Depot Btc</v-card-title>
        <v-card-text>
          <v-alert type="success" dismissible :value="true">
            une fois votre transaction confirmé votre compte sera automatiquement credité
          </v-alert>
          <div v-if="adre">
            <v-flex text-xs-center xs12>
              <div v-if="qr" style="text-align:center;"> 
                  <v-flex text-xs-center xs12>
                    <p class="caption red--text" v-if="warning"> Envoyez uniquement Bitcoin (BTC) à cette adresse</p>
                      <div @click="copy(btcAdr)" style="cursor:pointer;">
                        <qrcode-vue  class="" :value="btcAdr" size="170" level="H"></qrcode-vue>
                      </div>
                      <br />
                      <p @click="copy(btcAdr)" style="cursor:pointer;">{{btcAdr}}</p>
                      <p class="caption green--text" v-if="copied" style="line-height:30%;">Adresse BTC copié avec success!</p>
                      <p class="caption" v-if="!copied"  @click="copy(btcAdr)" style="cursor:pointer;line-height:50%;">cliquer sur l'adresse ou le QR pour copier</p>
                    </v-flex>
                </div>

                <v-layout column wrap>
                <v-flex xs6>
                  <v-btn color="success" class="mt-5" v-if="gen && btcAdr.length < 5" @click="generate">Generer</v-btn>
                </v-flex>

                <v-flex xs6>
                  <v-btn color="success" v-if="btcAdr.length > 5" @click="copy">copier</v-btn>
                </v-flex>
                <v-flex xs6>
                  <div class="text-xs-center">
                <!-- <Notify /> -->
              </div>
                </v-flex>
              </v-layout>
              <!-- <strong class="red--text"> option en maintenance pour ameliorer le service, revenez après un instant </strong> -->   
            </v-flex>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import { mapGetters, mapActions } from "vuex";
import firebase from '../../fb'
import axios from 'axios'
const Notify = () => import("../funds/Notify");
const copy = require('clipboard-copy')


export default {
  components: {
    QrcodeVue,
    Notify
  },
  data() {
    return {
      dialog: false,
      size: 170,
      copied: false,
      msg: "waiting...",
      etat: "attente",
      gen: true,
      qr: false,
      attente: false,
      warning: true,
      hh: false,
      btcAdr: '',
      recu: false,
      adre: true
    };
  },
  computed: {
    ...mapGetters({
      index: "deposit/index"
    })
  },
  mounted() {
    this.bindCoinpaymentBtc()
  },
  methods: {
    copy(address){
          copy(address)
          this.copied = true
          setTimeout(() => {
            this.copied = false
          }, 4000);
        },


    generate() {
      //let coinpayment_api =  `${this.main_api}/coinpayment`

      let base_url = this.base_url
              if (location.hostname === "localhost") {
                  base_url = 'http://localhost:4000'
                }
        //let url = base_url + '/coinpayment/coinpayment_generate'
        let url = base_url + '/coinbase_api/generate_address'


        let my_addresses =  this.$store.getters["deposit/address"]

      if (my_addresses ==undefined ||  my_addresses[`btc`]== undefined) {
        
        const loading = this.$vs.loading()
        if (location.hostname === "localhost") {
            //coinpayment_api = 'http://localhost:5000/hiropay-6c8a4/us-central1/coinpayment'
          }
          let user = firebase.auth().currentUser;
          let currency = 'BTC'
          console.log(url);
          axios.post(url, {
            currency:currency,
            type: 'deposit',
            user_id: user.uid
            }).then(res =>{
           let {address} = res.data
           console.log(address);
           loading.close()
           this.btcAdr = address
           this.qr = true;

          })
      } else {
        //this.btcAdr = this.$store.getters["deposit/coinpayment_btcAdr"]

        this.btcAdr = my_addresses[`btc`]
        this.qr = true
        
        this.qr = true
      }


      // if (this.$store.getters["deposit/btcObj"] == undefined) {
        
      //   const loading = this.$vs.loading()
      //   if (location.hostname === "localhost") {
      //       //coinpayment_api = 'http://localhost:5000/hiropay-6c8a4/us-central1/coinpayment'
      //     }
      //     let user = firebase.auth().currentUser;
      //     let currency = 'BTC'
      //     console.log(url);
      //     axios.post(url, {
      //       currency:currency,
      //       type: 'deposit',
      //       user_id: user.uid
      //       }).then(res =>{
      //      let {address} = res.data
      //      console.log(address);
      //      loading.close()
      //      this.btcAdr = address
      //      this.qr = true;

      //     })
      // } else {
      //   this.btcAdr = this.$store.getters["deposit/coinpayment_btcAdr"]
      //   console.log(this.$store.getters["deposit/coinpayment_btcAdr"]);
      //   this.qr = true
      // }
    },
    
    check_user(){
       let user = this.$store.getters['authfb/user']
      if (!user) {
        swal("Erreur survenu!", "contactez le support et fournissez votre email pour assistance avant d'effecturer le dépot!", "error", {
            button: "ok"
          })
          setTimeout(() => {
            this.dialog = false
          }, 1000);
        
      }
    },
    ...mapActions("deposit", ["bindCoinpaymentBtc"]),
  }
};
</script>

<style scoped>
.projet.attente {
  color: black;
}
.projet.attente {
  border-left: none;
}
.projet.recu {
  color: green;
}
</style>
